import React from "react";
import PropTypes from "prop-types";

import logger from "../../logger";

class AppErrorHandler extends React.Component {
  constructor() {
    super();

    this.state = {
      error: false,
    };
  }

  componentDidCatch(error, errorInfo) {
    const { handleErrorMessage } = this.props;

    this.setState({ error: true });
    console.error(
      "В шапке сломался слот:",
      this.props.slot,
      ", ошибка:",
      error
    );

    logger.error(error, {
      sentryTitle: `Header: the slot - ${this.props.slot} - has been broken`,
      additionalStack: {
        user: window?.atiUser,
        error,
        componentStack: errorInfo
          ? errorInfo.componentStack
          : "Empty errorInfo",
      },
    });

    if (handleErrorMessage) {
      handleErrorMessage(error);
    }
  }

  render() {
    if (this.state.error) {
      return null;
    }

    return this.props.children;
  }
}

AppErrorHandler.propTypes = {
  children: PropTypes.any,
  slot: PropTypes.string,
  handleErrorMessage: PropTypes.func,
};

export default AppErrorHandler;
